const UserBoundaryType = {
    MERCHANT: "MERCHANT", //only has access to the defined merchants
    GLOBAL: "GLOBAL", //global admin
    REGIONAL: "REGIONAL", //regional admin,
    ROOT: "ROOT",
};

export default UserBoundaryType;
